import { useMemo } from 'react';

import type { Trainer } from 'api';
import { useGetTrainersQuery } from 'store/examiners';

export const useFollowUpTrainers = () => {
  const { data: trainers, isLoading } = useGetTrainersQuery();

  const trainerOptions = useMemo(
    () =>
      trainers?.map((trainer: Trainer) => ({
        value: trainer.id,
        text: `${trainer.firstName} ${trainer.lastName}`,
      })) || [],
    [trainers]
  );

  return { trainerOptions, isLoading };
};
